import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { HelmetProvider } from 'react-helmet-async';
import "../i18n";
import LanguageBootstrap from "./components/LanguageBootstrap";

// ALL PAGE ROUTES
import routes from "./routes";
// REDUX STORE
import { store } from "./redux/Store";
// FAKE DB
import "../fake-db";

export default function App() {
  return (
    <HelmetProvider>
    <Provider store={store}>
      <LanguageBootstrap />
      <RouterProvider router={routes} />
      <ToastContainer />
    </Provider>
    </HelmetProvider>
  );
}

